app.controller('MasterController', ['$scope', '$log', function ($scope, $log) {
    $log.debug('Loading MasterController');
}]);
